import React, { useState } from "react";
import { saveUserData } from "../services/firestoreService";
import { AddMusicForm } from "./AddMusicForm";
import UserHobbies from "./UserHobbies";
import { AddMoviesForm } from "./AddMoviesForm";
import { AddBooksForm } from "./AddBooksForm";

export const UpdateHobbiesETCToFB = ({
	user,
	userData,
	setUserData,
	handleClose,
	setFbStatus,
	setShowToast,
	setToastVariant,
}) => {
	const [isUpdating, setIsUpdating] = useState(false);

	const handleUpdate = async () => {
		if (!user) {
			setFbStatus("User is not signed in.");
			return;
		}

		try {
			setIsUpdating(true);
			await saveUserData(user.uid, {
				hobbies: userData?.hobbies ? userData?.hobbies : [],
				music: userData?.music ? userData?.music : [],
				movies: userData?.movies ? userData?.movies : [],
				books: userData?.books ? userData?.books : [],
			});
			setFbStatus("Your interests were updated successfully!");
			handleClose();
			setShowToast(true);
			setToastVariant("success");
		} catch (error) {
			console.error("Error updating interests:", error);
			setFbStatus("Failed to update interests.");
			handleClose();
			setShowToast(true);
			setToastVariant("danger");
		} finally {
			setIsUpdating(false);
		}
	};

	return (
		<>
			<div className="mb-3">
				<UserHobbies userData={userData} setUserData={setUserData} />
			</div>
			<div className="mb-3">
				<AddMusicForm userData={userData} setUserData={setUserData} />
			</div>
			<div className="mb-3">
				<AddMoviesForm userData={userData} setUserData={setUserData} />
			</div>
			<div className="mb-3">
				<AddBooksForm userData={userData} setUserData={setUserData} />
			</div>
			{/* SUBMIT */}
			<button className="btn my-btn w-100" onClick={handleUpdate} disabled={isUpdating}>
				{isUpdating ? "Saving..." : "Save"}
			</button>
		</>
	);
};
